<template>
  <SidebarComponent />

  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">

        <!-- Titolo + filtri -->
        <div class="titolo-card">
          <div class="titolo-card__header">
            <h1>Elenco Questionari scaduti e in scadenza</h1>
            <div class="titolo-card__actions">
              <button
                v-if="canRunBackfill"
                type="button"
                class="btn ghost"
                :disabled="backfillRunning"
                @click="runBackfill"
              >
                {{ backfillRunning ? 'Aggiorno indice…' : (backfillCursorUserId ? 'Riprendi indice' : 'Aggiorna indice') }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="backfillStatus || backfillError" class="backfill-feedback">
          <span v-if="backfillStatus" class="muted">{{ backfillStatus }}</span>
          <span v-if="backfillError" class="error">{{ backfillError }}</span>
        </div>

        <section class="page-help page-help--questionari">
          <div class="page-help__header">
            <span class="page-help__title">Come leggere la pagina</span>
            <span class="page-help__subtitle">Significato degli stati e del periodo mostrato</span>
          </div>

          <div class="page-help__items">
            <div class="page-help__item">
              <strong>Scaduto</strong>
              <span>La data prevista e gia passata.</span>
            </div>
            <div class="page-help__item">
              <strong>In scadenza</strong>
              <span>La data prevista e oggi oppure cade nei prossimi giorni del range selezionato.</span>
            </div>
            <div class="page-help__item">
              <strong>Stato admin</strong>
              <span>Indica se il questionario e stato approvato, aggiornato o se richiede un nuovo intervento.</span>
            </div>
            <div class="page-help__item">
              <strong>Periodo iniziale</strong>
              <span>Di default vedi gli ultimi 30 giorni e i prossimi 7, cosi puoi gestire anche chi sta per scadere.</span>
            </div>
          </div>
        </section>

        <section class="toolbar-card card-surface">
          <div class="filters-header">
            <button
              type="button"
              class="accordion-toggle"
              @click="filtersOpen = !filtersOpen"
              :aria-expanded="filtersOpen"
            >
              <div class="toggle-copy">
                <span class="toggle-title">Filtri e ricerca</span>
                <span class="toggle-subtitle">Date previste, stato admin, step e studio</span>
              </div>
              <span class="material-icons" aria-hidden="true">
                {{ filtersOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </button>
          </div>

          <transition name="accordion">
            <div v-show="filtersOpen" class="accordion-panel">
              <div class="toolbar">

                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="qexp-from">Data prevista da</label>
                  <input
                    id="qexp-from"
                    type="date"
                    v-model="dateFrom"
                    class="input date-range-input date-range-input--short"
                    @change="refreshIndexSubscription"
                  />
                </div>

                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="qexp-to">a</label>
                  <input
                    id="qexp-to"
                    type="date"
                    v-model="dateTo"
                    class="input date-range-input date-range-input--short"
                    @change="refreshIndexSubscription"
                  />
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="qexp-admin">Stato admin</label>
                  <select id="qexp-admin" v-model="selectedAdmin" class="input" @change="applyCombinedFilter">
                    <option value="">Tutti</option>
                    <option value="approved">Approvato</option>
                    <option value="needs_update">Richiesto aggiornamento</option>
                    <option value="updated">Aggiornato</option>
                    <option value="todo">Da lavorare</option>
                    <option value="none">—</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="qexp-step">Step</label>
                  <select id="qexp-step" v-model="selectedStepKey" class="input" @change="applyCombinedFilter">
                    <option value="">Tutti</option>
                    <option value="questionario">questionario</option>
                    <option value="check_finale">check_finale</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="qexp-timing">Scadenza</label>
                  <select id="qexp-timing" v-model="selectedTiming" class="input" @change="applyCombinedFilter">
                    <option value="">Tutti</option>
                    <option value="expired">Scaduti</option>
                    <option value="expiring">In scadenza</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="qexp-rating">Valutazione</label>
                  <select id="qexp-rating" v-model="selectedValutazione" class="input" @change="applyCombinedFilter">
                    <option value="">Tutte</option>
                    <option value="1-2">1–2</option>
                    <option value="3">3</option>
                    <option value="4-5">4–5</option>
                  </select>
                </div>

                <div class="toolbar-group toolbar-group--lg">
                  <label class="toolbar-label" for="qexp-studio">Studio</label>
                  <select id="qexp-studio" v-model="selectedStudio" class="input" @change="applyCombinedFilter">
                    <option value="">Tutti</option>
                    <option v-for="studio in studioOptions" :key="studio" :value="studio">
                      {{ studio }}
                    </option>
                  </select>
                </div>

                <div class="toolbar-actions">
                  <button class="btn primary staff-button-neutral" type="button" @click="refreshIndexSubscription">Cerca</button>
                  <button class="btn ghost" @click="resetFilters">Reset</button>
                </div>

                <div class="toolbar-actions toolbar-actions--ghosts">
                  <button
                    class="btn ghost"
                    :class="{ active: showImported }"
                    type="button"
                    @click="toggleImported"
                  >
                    {{ showImported ? 'Nascondi importati' : 'Mostra importati' }}
                  </button>

                  <button
                    class="btn ghost"
                    :class="{ active: showSuperseded }"
                    type="button"
                    @click="toggleShowSuperseded"
                  >
                    {{ showSuperseded
                      ? 'Nascondi scaduti superati'
                      : 'Mostra scaduti superati'
                    }}
                  </button>

                  <button
                    class="btn ghost"
                    :class="{ active: showHidden }"
                    type="button"
                    @click="toggleShowHidden"
                  >
                    {{ showHidden ? 'Nascondi nascosti' : 'Mostra nascosti' }}
                  </button>

                  <button
                    class="btn ghost"
                    :class="{ active: showOperationalHold }"
                    type="button"
                    @click="toggleShowOperationalHold"
                  >
                    {{ showOperationalHold ? 'Nascondi sospesi' : 'Mostra sospesi' }}
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </section>

        <!-- Loader -->
        <div v-if="isLoading" class="loader"><h4>Caricamento…</h4></div>

        <!-- Tabella -->
        <template v-else>
          <div v-if="filteredQuestionari.length" class="tickets">
            <table>
              <thead>
                <tr>
                  <th class="col-idx">#</th>
                  <th class="col-azione">Azioni</th>
                  <th class="col-admin">Stato admin</th>
                  <th class="col-note">Note</th>
                  <th class="col-data">Data (prevista)</th>
                  <th class="col-email">Utente (email)</th>
                  <th class="col-prodotto">Prodotto</th>
                  <th class="col-sequenza">Sequenza</th>
                  <th class="col-step">Step</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="entry in questionariDisplayRows" :key="entry.key">
                  <tr
                    v-if="entry.type === 'group'"
                    class="user-questionari-group-row"
                    :class="{ 'is-open': isUserGroupOpen(entry.group.key) }"
                  >
                    <td class="mono">{{ entry.displayIndex }}</td>
                    <td colspan="8">
                      <div class="user-questionari-group">
                        <button
                          type="button"
                          class="user-questionari-group__toggle"
                          @click="toggleUserGroup(entry.group.key)"
                          :aria-expanded="isUserGroupOpen(entry.group.key) ? 'true' : 'false'"
                        >
                          <span class="material-icons" aria-hidden="true">
                            {{ isUserGroupOpen(entry.group.key) ? 'expand_less' : 'expand_more' }}
                          </span>
                          <span class="user-questionari-group__copy">
                            <strong>{{ entry.group.userEmail || '—' }}</strong>
                            <span>{{ questionariGroupSubtitle(entry.group) }}</span>
                          </span>
                        </button>
                        <div class="user-questionari-group__meta">
                          <span class="admin-chip chip-yellow">
                            {{ entry.group.rows.length }} righe
                          </span>
                          <span class="admin-chip chip-yellow">
                            {{ questionariGroupDateRange(entry.group) }}
                          </span>
                          <span
                            v-if="questionariGroupSequenceLabel(entry.group)"
                            class="admin-chip chip-yellow"
                          >
                            {{ questionariGroupSequenceLabel(entry.group) }}
                          </span>
                          <button
                            class="profile-button profile-button--group"
                            @click="gotoUser(entry.group.uid)"
                            :disabled="!entry.group.uid"
                            title="Apri anagrafica utente"
                          >
                            <span class="material-icons">visibility</span>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr
                    v-else
                    :class="[
                      feedbackColor(entry.row),
                      {
                        'row-imported': entry.row.isImported,
                        'user-questionari-child-row': entry.isGroupedChild
                      }
                    ]"
                  >
                    <td class="mono">{{ entry.displayIndex }}</td>

                    <td>
                      <button
                        class="profile-button"
                        @click="handleQuestionarioClick(entry.row)"
                        :title="questionarioLinkLabel(entry.row)"
                      >
                        <span class="material-icons">article</span>
                      </button>
                      <button class="profile-button" @click="gotoUser(entry.row.uid)" :disabled="!entry.row.uid">
                        <span class="material-icons">visibility</span>
                      </button>
                    </td>

                    <!-- ======= STATO ADMIN ======= -->
                    <td class="admin-col">
                      <div class="admin-row">
                        <div class="chips-line">
                          <span class="admin-chip" :class="adminChipClass(entry.row.adminStatus)">
                            {{ adminLabel(entry.row.adminStatus) }}
                          </span>
                          <span v-if="entry.row.isImported" class="admin-chip chip-blue">
                            Importato
                          </span>
                          <span v-if="entry.row.adminHidden" class="admin-chip chip-dark">
                            Nascosto
                          </span>
                          <span v-if="isOperationallyHidden(entry.row)" class="admin-chip chip-dark">
                            Sospeso
                          </span>
                          <span v-if="entry.row.hasRenewalAfterCompletedSequence" class="admin-chip chip-yellow">
                            Nuovo percorso
                          </span>
                        </div>
                        <div class="buttons-container">
                          <button
                            type="button"
                            class="grey"
                            @click="sendAdminNotification(entry.row)"
                            :disabled="entry.row._sendingNotification || !entry.row.percorsoIdValid"
                          >
                            {{ entry.row._sendingNotification ? 'Invio…' : 'Invia notifica' }}
                          </button>
                          <button
                            type="button"
                            class="dark"
                            :disabled="entry.row._togglingHidden || !entry.row.percorsoIdValid"
                            @click="toggleHidden(entry.row)"
                          >
                            {{ entry.row._togglingHidden ? 'Aggiorno…' : (entry.row.adminHidden ? 'Ripristina' : 'Nascondi') }}
                          </button>
                        </div>
                      </div>

                      <small v-if="(entry.row.adminNote||'').length" class="muted">
                        Nota: “{{ entry.row.adminNote }}”
                      </small>
                    </td>

                    <!-- ======= NOTE (editable) ======= -->
                    <td>
                      <input
                        class="note-input"
                        :placeholder="'—'"
                        v-model="staffNoteEdits[keyFor(entry.row)]"
                        @blur="saveStaffNote(entry.row)"
                        @keyup.enter="saveStaffNote(entry.row)"
                        :disabled="!entry.row.percorsoIdValid || entry.row._savingNote"
                      />
                      <small v-if="entry.row._savingNote" class="muted">salvo…</small>
                      <small v-else-if="saveStatus[keyFor(entry.row)]==='ok'" class="muted">salvato ✓</small>
                      <small v-else-if="saveStatus[keyFor(entry.row)]==='err'" class="muted">errore ✗</small>
                    </td>

                    <!-- Data prevista scaduta -->
                    <td>
                      <div class="planned-at-cell">
                        <span>{{ formatDateTime(entry.row.plannedAt) }}</span>
                        <span class="admin-chip" :class="timingChipClass(entry.row)">
                          {{ timingLabel(entry.row) }}
                        </span>
                      </div>
                    </td>
                    <td class="mono">{{ entry.row.userEmail || '—' }}</td>
                    <td>{{ entry.row.productName || '—' }}</td>
                    <td>
                      <span v-if="entry.row.sequenceIndex != null">
                        {{ entry.row.sequenceIndex }}<span v-if="entry.row.sequenceTotal">/{{ entry.row.sequenceTotal }}</span>
                      </span>
                      <span v-else>—</span>
                    </td>
                    <td class="mono">
                      <div class="step-cell">
                        <span>{{ entry.row.stepKey || '—' }}</span>
                        <span v-if="stepCloneLabel(entry.row)" class="step-tag">· {{ stepCloneLabel(entry.row) }}</span>
                        <span v-if="entry.row.isImported" class="step-tag step-tag--imported">· importato</span>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>

          <div v-else class="muted">Nessun elemento nel range selezionato.</div>
        </template>
      </div>
    </div>
  </div>

  <!-- Modale dettagli -->
  <div v-if="showModal" class="modal">
    <div class="dialog">
      <div class="modal-head">
        <h3>Dettagli step</h3>
        <div class="head-actions">
          <input v-model.trim="modalSearch" class="input input--compact" placeholder="Filtra campi…" />
          <button class="btn ghost tiny" @click="closeModal">Chiudi</button>
        </div>
      </div>

      <div class="modal-scroll">
        <div class="meta">
          <div><strong>Email:</strong> <span class="mono">{{ activeRow?.userEmail || '—' }}</span></div>
          <div><strong>Prodotto:</strong> {{ activeRow?.productName || '—' }}</div>
          <div class="meta-step">
            <strong>Step:</strong>
            <span>{{ activeRow?.stepKey || '—' }}</span>
            <span v-if="stepCloneLabel(activeRow)" class="step-tag">· {{ stepCloneLabel(activeRow) }}</span>
          </div>
          <div><strong>Data prevista:</strong> {{ formatDateTime(activeRow?.plannedAt) }}</div>
          <div><strong>Sequenza:</strong>
            <template v-if="activeRow?.sequenceIndex != null">
              {{ activeRow.sequenceIndex }}<template v-if="activeRow?.sequenceTotal">/{{ activeRow.sequenceTotal }}</template>
            </template>
            <template v-else>—</template>
          </div>
          <div><strong>Stato admin:</strong> {{ adminLabel(activeRow?.adminStatus) }}</div>
          <div v-if="activeRow?.adminNote"><strong>Nota:</strong> “{{ activeRow.adminNote }}”</div>
        </div>

        <div class="answers">
          <div v-if="modalLoading" class="data-state">Caricamento dati…</div>
          <div v-else-if="modalBundleError" class="data-state error">{{ modalBundleError }}</div>
          <template v-else>
            <div v-if="modalSections.length" class="modal-sections">
              <section v-for="section in modalSections" :key="section.key" class="modal-section">
                <header class="modal-section__head">
                  <div>
                    <h4>{{ section.title }}</h4>
                    <p v-if="section.subtitle" class="modal-section__subtitle">{{ section.subtitle }}</p>
                  </div>
                  <div v-if="section.meta" class="modal-section__meta">{{ section.meta }}</div>
                </header>
                <div v-if="section.groups.length" class="modal-section__body">
                  <div
                    v-for="group in section.groups"
                    :key="group.key || group.title || group.rootLabel"
                    class="modal-group"
                  >
                    <h5 v-if="group.title" class="modal-group__title">{{ group.title }}</h5>
                    <div
                      v-for="entry in group.entries"
                      :key="entry.key"
                      class="modal-row"
                      :class="{ multiline: entry.multiline }"
                    >
                      <div class="modal-row__key mono">{{ entry.labelInGroup }}</div>
                      <div class="modal-row__value">
                        <pre v-if="entry.multiline">{{ entry.display }}</pre>
                        <span v-else>{{ entry.display }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="data-state muted">Nessun campo corrisponde al filtro.</div>
              </section>
            </div>
            <div v-else class="data-state muted">Nessun campo corrisponde al filtro.</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarComponent from '../SidebarComponent.vue';
import {
  getFirestore,
  collection,
  query,
  onSnapshot,
  doc,
  getDoc,
  updateDoc,
  getDocs,
  where,
  orderBy,
} from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {
  flattenAnswers,
  prettifyKey,
  buildQuestionarioSections,
  buildCheckFinaleSections,
} from '../../lib/questionarioDisplay.js';
import {
  normalizeProgramTitle,
  dispatchStepNotification,
} from '../../lib/percorsoStepNotifications';
import {
  getOperationalHoldReasonLabel,
  shouldHideFromOperationalLists,
} from '@/lib/operationalHold';

const BACKFILL_BATCH_SIZE = 25;
const BACKFILL_MAX_LOOPS = 250;

const toDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
  if (value?.toDate) {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/* // Helpers per riconoscere percorsi bloccati (versione compatta di UserProgrammi)
const toComparableString = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value instanceof Date) return value.toISOString();
  if (typeof value?.toDate === 'function') {
    try { return value.toDate().toISOString(); } catch { return ''; }
  }
  return String(value);
};
const isConsulenzaStatusDone = (status) => {
  const norm = String(status || '').toLowerCase();
  return norm === 'fatta' || norm === 'rifiutata' || norm === 'scalata' || norm === 'scalato';
};
const isBlockingStepForSequence = (step) => {
  const name = (step?.name || '').toLowerCase();
  if (!name) return true;
  if (name.includes('feedback')) return false;
  return true;
};
const isStepEffectivelyDone = (step) => {
  if (!step) return false;
  const name = (step?.name || '').toLowerCase();
  if (name.includes('consulenza') && isConsulenzaStatusDone(step?.consulenzaStatus)) return true;
  return !!step?.done;
};
const hasCheckFinaleDone = (steps = []) =>
  (Array.isArray(steps) ? steps : []).some((step) => {
    const name = (step?.name || '').toLowerCase();
    const isCheck = name.includes('check') || name.includes('scadenza');
    return isCheck && isStepEffectivelyDone(step);
  });
const blockingStepsOnly = (steps = []) =>
  (Array.isArray(steps) ? steps : []).filter(isBlockingStepForSequence);
const isPercorsoFullyCompleted = (percorso) => {
  const steps = Array.isArray(percorso?.steps) ? percorso.steps : [];
  if (!steps.length) return false;
  if (hasCheckFinaleDone(steps)) return true;
  const blocking = blockingStepsOnly(steps);
  if (!blocking.length) return true;
  return blocking.every(isStepEffectivelyDone);
};
const isPercorsoHistoryLocked = (percorso) => !!(percorso?.historyLocked);
const hasSequenceUnlockOverride = (percorso) => percorso?.sequenceUnlockOverride === true;
const isPercorsoCompleteForLocking = (percorso) =>
  isPercorsoFullyCompleted(percorso) || isPercorsoHistoryLocked(percorso);
const buildSequentialLocks = (list = []) => {
  const locks = {};
  const groups = new Map();
  for (const percorso of list) {
    if (!percorso?.id) continue;
    const gid = percorso.sequenceGroupId || percorso.id;
    const arr = groups.get(gid) || [];
    arr.push(percorso);
    groups.set(gid, arr);
  }
  const sortBySequence = (a, b) => {
    const ix = Number(a?.sequenceIndex) || 0;
    const iy = Number(b?.sequenceIndex) || 0;
    if (ix !== iy) return ix - iy;
    const ax = toComparableString(a?.plannedStartAt || a?.createdAt);
    const ay = toComparableString(b?.plannedStartAt || b?.createdAt);
    return ax.localeCompare(ay);
  };
  for (const listItem of groups.values()) {
    if (!listItem.length) continue;
    const sorted = [...listItem].sort(sortBySequence);
    const gatingActive = sorted.length > 1 || Number(sorted[0]?.sequenceTotal) > 1;
    let blockNext = false;
    sorted.forEach((percorso) => {
      if (!gatingActive) {
        locks[percorso.id] = false;
        return;
      }
      const override = hasSequenceUnlockOverride(percorso);
      locks[percorso.id] = blockNext && !override;
      const isComplete = isPercorsoCompleteForLocking(percorso);
      blockNext = !isComplete;
    });
  }
  return locks;
};
const buildPreviousGroupLocks = (list = []) => {
  const locks = {};
  const groups = new Map();
  const ordered = [];

  for (const percorso of list) {
    if (!percorso?.id) continue;
    const gid = percorso.sequenceGroupId || percorso.id;
    const anchor = toComparableString(percorso.plannedStartAt || percorso.createdAt);
    let group = groups.get(gid);
    if (!group) {
      group = { id: gid, anchor, percorsi: [] };
      groups.set(gid, group);
      ordered.push(group);
    } else if (anchor && (!group.anchor || anchor < group.anchor)) {
      group.anchor = anchor;
    }
    group.percorsi.push(percorso);
  }

  ordered.sort((a, b) => (a.anchor || '').localeCompare(b.anchor || ''));

  let blockFollowing = false;
  for (const group of ordered) {
    const listItem = group.percorsi || [];
    const groupCompleted = listItem.every(
      (p) => hasSequenceUnlockOverride(p) || isPercorsoCompleteForLocking(p)
    );

    listItem.forEach((percorso) => {
      locks[percorso.id] = blockFollowing && !hasSequenceUnlockOverride(percorso);
    });

    if (!groupCompleted) blockFollowing = true;
  }

  return locks;
};
const isPercorsoLocked = (percorso, seqLocks = {}, prevLocks = {}) => {
  if (!percorso || !percorso.id) return false;
  if (hasSequenceUnlockOverride(percorso)) return false;
  if (isPercorsoHistoryLocked(percorso)) return true;
  if (prevLocks[percorso.id]) return true;
  if (seqLocks[percorso.id]) return true;
  return false;
};
*/
export default {
  name: 'QuestionariUsersScaduti',
  components: { SidebarComponent },

  data() {
    const today = new Date();
    const from = new Date(today);
    from.setDate(from.getDate() - 30);
    const to = new Date(today);
    to.setDate(to.getDate() + 7);
    const defaultDateFrom = from.toISOString().slice(0, 10);
    const defaultDateTo = to.toISOString().slice(0, 10);

    return {
      // dataset
      savedQuestionari: [],
      rawFilteredData: [],
      filteredQuestionari: [],
      isLoading: true,
      filtersOpen: false,
      openUserGroups: {},

      // filtri
      searchText: '',
      selectedAdmin: '',
      selectedStepKey: '',
      selectedTiming: '',
      selectedValutazione: '',
      selectedStudio: '',
      showImported: true,
      showSuperseded: false,
      showHidden: false,
      showOperationalHold: false,
      dateFrom: defaultDateFrom,
      dateTo: defaultDateTo,

      indexUnsub: null,
      authUnsub: null,
      operatorUid: '',
      backfillRunning: false,
      backfillStatus: '',
      backfillError: '',
      backfillCursorUserId: '',

      // modale
      showModal: false,
      activeRow: null,
      modalSearch: '',
      modalBundle: null,
      modalBundleError: '',
      modalLoading: false,
      bundleCache: {},

      // note staff
      staffNoteEdits: {},
      saveStatus: {}
    };
  },

  mounted() {
    const auth = getAuth();
    this.operatorUid = auth.currentUser?.uid || '';
    this.authUnsub = onAuthStateChanged(auth, (user) => {
      this.operatorUid = user?.uid || '';
    });
    this.refreshIndexSubscription();
  },
  beforeUnmount() {
    if (typeof this.indexUnsub === 'function') {
      this.indexUnsub();
    }
    if (typeof this.authUnsub === 'function') {
      this.authUnsub();
    }
  },

  computed: {
    canRunBackfill() {
      return !!this.operatorUid;
    },

    modalSections() {
      if (!this.activeRow) return [];
      const sections = [];
      const search = this.modalSearch;
      const bundle = this.modalBundle || {};
      const activeDocId = this.activeRow?.questionarioDocId || null;

      const addSection = (key, title, subtitle, info, answers, typeKey) => {
        const groups = this.buildSectionGroups(typeKey, answers, search);
        if (!groups.length) return;
        sections.push({
          key,
          title,
          subtitle: subtitle || '',
          meta: info?.updatedAt
            ? `Aggiornato: ${this.formatDateTime(info.updatedAt)}`
            : info?.createdAt
            ? `Creato: ${this.formatDateTime(info.createdAt)}`
            : '',
          groups,
        });
      };

      if (bundle.questionario) {
        addSection(
          'questionario',
          'Questionario Programmi',
          bundle.questionario.templateLabel,
          bundle.questionario,
          bundle.questionario.answers,
          'questionario'
        );
      }

      if (bundle.checkFinale) {
        addSection(
          'check_finale',
          'Check Finale Programmi',
          bundle.checkFinale.templateLabel,
          bundle.checkFinale,
          bundle.checkFinale.answers,
          'check_finale'
        );
      }

      const currentIsKnown =
        (bundle.questionario && bundle.questionario.docId === activeDocId) ||
        (bundle.checkFinale && bundle.checkFinale.docId === activeDocId);

      if (!currentIsKnown) {
        const createdAt = this.activeRow?.createdAt ? new Date(this.activeRow.createdAt) : null;
        const updatedAt = this.activeRow?.updatedAt ? new Date(this.activeRow.updatedAt) : null;
        addSection(
          'current',
          this.sectionTitle(this.activeRow),
          this.sectionSubtitle(this.activeRow),
          { createdAt, updatedAt },
          this.activeRow.answers || {},
          (this.activeRow?.stepKey || '').toLowerCase()
        );
      }

      return sections;
    },

    studioOptions() {
      const opts = new Set();
      (this.savedQuestionari || []).forEach((row) => {
        const studio = row?.userStudio || '';
        if (studio && studio !== '—') {
          opts.add(studio);
        }
      });
      return Array.from(opts).sort((a, b) => a.localeCompare(b));
    },

    questionariDisplayRows() {
      const groups = this.buildQuestionariUserGroups(this.filteredQuestionari || []);
      const displayRows = [];

      groups.forEach((group, groupIndex) => {
        const displayIndex = groupIndex + 1;

        if (group.rows.length > 1) {
          displayRows.push({
            type: 'group',
            key: `group-${group.key}`,
            displayIndex,
            group,
          });

          if (this.isUserGroupOpen(group.key)) {
            group.rows.forEach((row, rowIndex) => {
              displayRows.push({
                type: 'row',
                key: `group-row-${group.key}-${row.id || rowIndex}`,
                displayIndex: `${displayIndex}.${rowIndex + 1}`,
                row,
                isGroupedChild: true,
              });
            });
          }
          return;
        }

        const row = group.rows[0];
        displayRows.push({
          type: 'row',
          key: `row-${row?.id || group.key}`,
          displayIndex,
          row,
          isGroupedChild: false,
        });
      });

      return displayRows;
    }
  },

  methods: {

    defaultDateRange() {
      const today = new Date();
      const from = new Date(today);
      from.setDate(from.getDate() - 30);
      const to = new Date(today);
      to.setDate(to.getDate() + 7);
      return {
        from: from.toISOString().slice(0, 10),
        to: to.toISOString().slice(0, 10),
      };
    },

    // Normalizza qualsiasi valore data (Timestamp, ISO, 'YYYY-MM-DD', Date, null) -> Date | null
    asDate(v) {
      try {
        if (!v) return null;
        if (v && typeof v.toDate === 'function') return v.toDate();
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
          return new Date(v + 'T00:00:00.000Z');
        }
        const d = new Date(v);
        return isNaN(d) ? null : d;
      } catch {
        return null;
      }
    },


    /* ===== mapping nome->key ===== */
    stepKeyFromName(name = '') {
      const n = (name || '').toLowerCase();
      if (n.includes('questionario')) return 'questionario';
      if (n.includes('feedback'))     return 'feedback_programmi';
      if (n.includes('check') || n.includes('scadenza')) return 'check_finale';
      if (n.includes('consegna'))     return 'consegna';
      return null;
    },

    normalizeStepsArray(steps) {
      if (Array.isArray(steps)) {
        return steps.map((step) => (step && typeof step === 'object' ? { ...step } : step));
      }
      if (steps && typeof steps === 'object') {
        return Object.keys(steps)
          .sort((a, b) => Number(a) - Number(b))
          .map((key) => {
            const step = steps[key];
            return step && typeof step === 'object' ? { ...step } : step;
          });
      }
      return [];
    },

    /* ===== utility ===== */
    keyFor(row) { return `${row.percorsoId || 'nop'}__${row.stepIndex ?? 'x'}`; },

    userGroupKeyFor(row) {
      const uid = String(row?.uid || '').trim();
      if (uid) return `uid:${uid}`;

      const email = String(row?.userEmail || '').trim().toLowerCase();
      if (email && email !== '—') return `email:${email}`;

      const fallback = `${row?.percorsoId || 'nop'}:${row?.stepIndex ?? 'x'}:${row?.plannedAt || ''}`;
      return `row:${row?.id || fallback}`;
    },

    buildQuestionariUserGroups(rows = []) {
      const map = new Map();

      rows.forEach((row) => {
        const key = this.userGroupKeyFor(row);
        if (!map.has(key)) {
          map.set(key, {
            key,
            uid: row?.uid || '',
            userEmail: row?.userEmail || '—',
            userStudio: row?.userStudio || '',
            rows: [],
          });
        }

        const group = map.get(key);
        if (!group.uid && row?.uid) group.uid = row.uid;
        if ((!group.userEmail || group.userEmail === '—') && row?.userEmail) {
          group.userEmail = row.userEmail;
        }
        group.rows.push(row);
      });

      return Array.from(map.values()).map((group) => {
        group.rows.sort((a, b) => String(a?.plannedAt || '').localeCompare(String(b?.plannedAt || '')));
        return group;
      });
    },

    isUserGroupOpen(key) {
      return !!this.openUserGroups[key];
    },

    toggleUserGroup(key) {
      if (!key) return;
      this.openUserGroups = {
        ...this.openUserGroups,
        [key]: !this.openUserGroups[key],
      };
    },

    uniqueTextList(values = [], max = 3) {
      const unique = Array.from(new Set(
        values
          .map((value) => String(value || '').trim())
          .filter(Boolean)
      ));
      if (unique.length <= max) return unique.join(', ');
      return `${unique.slice(0, max).join(', ')} +${unique.length - max}`;
    },

    rowSequenceLabel(row) {
      if (row?.sequenceIndex == null) return '';
      return `${row.sequenceIndex}${row.sequenceTotal ? `/${row.sequenceTotal}` : ''}`;
    },

    questionariGroupSequenceLabel(group) {
      return this.uniqueTextList((group?.rows || []).map(this.rowSequenceLabel), 4);
    },

    questionariGroupDateRange(group) {
      const dates = (group?.rows || [])
        .map((row) => this.asDate(row?.plannedAt))
        .filter((date) => date instanceof Date && !Number.isNaN(date.getTime()))
        .sort((a, b) => a.getTime() - b.getTime());

      if (!dates.length) return 'Date non disponibili';

      const first = dates[0];
      const last = dates[dates.length - 1];
      if (first.toDateString() === last.toDateString()) {
        return this.formatDate(first);
      }
      return `${this.formatDate(first)} - ${this.formatDate(last)}`;
    },

    questionariGroupSubtitle(group) {
      const rows = group?.rows || [];
      const countLabel = `${rows.length} questionari nel periodo selezionato`;
      const productLabel = this.uniqueTextList(rows.map((row) => row.productName || row.programLabel), 2);
      const stepLabel = this.uniqueTextList(rows.map((row) => row.stepKey), 2);
      const parts = [countLabel, this.questionariGroupDateRange(group)];
      if (productLabel) parts.push(productLabel);
      if (stepLabel) parts.push(stepLabel);
      return parts.join(' · ');
    },

    feedbackColor(q) {
      if (q.stepKey !== 'feedback_programmi') return '';
      const val = Number(q.answers?.valutazione);
      if ([1, 2].includes(val)) return 'fb-red';
      if (val === 3) return 'fb-orange';
      if ([4, 5].includes(val)) return 'fb-green';
      return '';
    },

    isOperationallyHidden(row) {
      return shouldHideFromOperationalLists(row || {});
    },

    operationalHoldLabel(row) {
      return getOperationalHoldReasonLabel(row?.operationalHoldReason);
    },

    passValutazione(row) {
      if (!this.selectedValutazione) return true;
      if (!row) return false;
      const answers = row.answers
        || row.stepSnapshot?.answers
        || row.stepSnapshot?.questionnaire?.answers
        || {};
      const val = Number(answers?.valutazione);
      if (Number.isNaN(val)) return false;
      if (this.selectedValutazione === '1-2') return val === 1 || val === 2;
      if (this.selectedValutazione === '3') return val === 3;
      if (this.selectedValutazione === '4-5') return val === 4 || val === 5;
      return true;
    },

    /* ===== indice questionari scaduti ===== */
    normalizeIndexRow(docSnap) {
      const data = docSnap.data() || {};
      const plannedAt = this.asDate(data.plannedAt || data.stepSnapshot?.plannedAt);
      const createdAt = this.asDate(data.createdAt || data.stepSnapshot?.questionnaire?.createdAt);
      const updatedAt = this.asDate(
        data.updatedAt ||
        data.stepSnapshot?.questionnaire?.updatedAt ||
        data.stepSnapshot?.adminUpdatedAt
      );
      const answers = data.answers
        || data.stepSnapshot?.answers
        || data.stepSnapshot?.questionnaire?.answers
        || {};
      const stepSnapshot = data.stepSnapshot && typeof data.stepSnapshot === 'object'
        ? { ...data.stepSnapshot }
        : {};

      if (plannedAt && !stepSnapshot.plannedAt) {
        stepSnapshot.plannedAt = plannedAt.toISOString();
      }

      return {
        ...data,
        id: docSnap.id,
        plannedAt: plannedAt ? plannedAt.toISOString() : null,
        createdAt: createdAt ? createdAt.toISOString() : null,
        updatedAt: updatedAt ? updatedAt.toISOString() : null,
        answers,
        stepSnapshot,
        userEmail: data.userEmail || '—',
        userStudio: data.userStudio || '',
        operationalHold: data.operationalHold || null,
        operationalHoldActive: data.operationalHoldActive === true,
        operationalHoldReason: data.operationalHoldReason || '',
        operationalHoldNote: data.operationalHoldNote || '',
        operationalHoldHideFromOperationalLists: data.operationalHoldHideFromOperationalLists === true,
        operationalHoldSuppressNotifications: data.operationalHoldSuppressNotifications === true,
        adminStatus: data.adminStatus || 'none',
        adminHidden: !!data.adminHidden,
        adminNote: data.adminNote ?? null,
        staffNote: data.staffNote || '',
        isImported: !!data.isImported,
        hasCompletedLater: !!data.hasCompletedLater,
        hasRenewalAfterCompletedSequence: !!data.hasRenewalAfterCompletedSequence,
        percorsoIdValid: !!data.percorsoId,
        _savingNote: false,
        _sendingNotification: false,
        _togglingHidden: false,
      };
    },

    currentQueryBounds() {
      const from = this.dateFrom ? this.asDate(this.dateFrom) : null;
      const to = this.dateTo ? this.asDate(this.dateTo) : null;
      const upperBound = to
        ? new Date(new Date(to).setHours(23, 59, 59, 999))
        : null;

      if (from && upperBound && from.getTime() > upperBound.getTime()) {
        return { from, to: upperBound, isEmpty: true };
      }

      return { from, to: upperBound, isEmpty: false };
    },

    timingState(row) {
      const planned = this.asDate(row?.plannedAt);
      if (!planned) return 'neutral';

      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);

      return planned.getTime() < todayStart.getTime() ? 'expired' : 'expiring';
    },

    timingLabel(row) {
      return this.timingState(row) === 'expired' ? 'Scaduto' : 'In scadenza';
    },

    timingChipClass(row) {
      return this.timingState(row) === 'expired' ? 'chip-red' : 'chip-purple';
    },

    buildIndexQuery(db, bounds) {
      const constraints = [];
      if (bounds?.from instanceof Date && !Number.isNaN(bounds.from.getTime())) {
        constraints.push(where('plannedAt', '>=', bounds.from));
      }
      if (bounds?.to instanceof Date && !Number.isNaN(bounds.to.getTime())) {
        constraints.push(where('plannedAt', '<=', bounds.to));
      }
      constraints.push(orderBy('plannedAt', 'asc'));
      return query(collection(db, 'questionari_steps_index'), ...constraints);
    },

    setIndexRows(rows = []) {
      const normalizedRows = [...rows].sort((a, b) =>
        String(a.plannedAt || '').localeCompare(String(b.plannedAt || ''))
      );
      const nextNoteEdits = { ...this.staffNoteEdits };

      normalizedRows.forEach((row) => {
        const key = this.keyFor(row);
        if (nextNoteEdits[key] == null) {
          nextNoteEdits[key] = row.staffNote || '';
        }
      });

      this.staffNoteEdits = nextNoteEdits;
      this.savedQuestionari = normalizedRows;
      this.rawFilteredData = [...normalizedRows];
      this.applyCombinedFilter();
    },

    refreshIndexSubscription() {
      const db = getFirestore();
      const bounds = this.currentQueryBounds();

      if (typeof this.indexUnsub === 'function') {
        this.indexUnsub();
        this.indexUnsub = null;
      }

      if (bounds.isEmpty) {
        this.setIndexRows([]);
        this.isLoading = false;
        return;
      }

      this.isLoading = true;
      const indexQuery = this.buildIndexQuery(db, bounds);

      this.indexUnsub = onSnapshot(indexQuery, (snap) => {
        const rows = snap.docs.map((docSnap) => this.normalizeIndexRow(docSnap));
        this.setIndexRows(rows);
        this.isLoading = false;
      }, (error) => {
        console.error('listenRT questionari_steps_index error:', error);
        this.setIndexRows([]);
        this.isLoading = false;
      });
    },

    async runBackfill() {
      if (this.backfillRunning) return;

      this.backfillRunning = true;
      this.backfillError = '';
      this.backfillStatus = this.backfillCursorUserId
        ? 'Ripresa aggiornamento indice questionari…'
        : 'Aggiornamento indice questionari in corso…';

      try {
        const functions = getFunctions(undefined, 'us-central1');
        const callable = httpsCallable(functions, 'backfillQuestionariStepsIndex', {
          timeout: 120000,
        });

        let nextUserId = this.backfillCursorUserId || '';
        let hasMoreUsers = true;
        let loop = 0;
        let totalUsers = 0;
        let totalPercorsi = 0;
        let totalWritten = 0;
        let totalDeleted = 0;

        while (hasMoreUsers) {
          loop += 1;
          if (loop > BACKFILL_MAX_LOOPS) {
            throw new Error('Limite di iterazioni superato. Riprova per continuare dal punto corrente.');
          }

          const payload = { batchSize: BACKFILL_BATCH_SIZE };
          if (nextUserId) {
            payload.startAfterUserId = nextUserId;
          }

          const res = await callable(payload);
          const data = res?.data || {};
          const processedUsers = Number(data.processedUsers || 0);
          const processedPercorsi = Number(data.processedPercorsi || 0);
          const written = Number(data.written || 0);
          const deleted = Number(data.deleted || 0);

          totalUsers += processedUsers;
          totalPercorsi += processedPercorsi;
          totalWritten += written;
          totalDeleted += deleted;

          hasMoreUsers = Boolean(data.hasMoreUsers);
          nextUserId = String(data.nextUserId || '');
          this.backfillCursorUserId = hasMoreUsers ? nextUserId : '';

          this.backfillStatus =
            `Aggiornamento indice: passo ${loop} ` +
            `(${totalUsers} utenti, ${totalPercorsi} percorsi, ` +
            `${totalWritten} righe, ${totalDeleted} rimosse)`;

          if (!hasMoreUsers) break;

          if (processedUsers === 0) {
            throw new Error('Nessun progresso nel backfill. Riprova per continuare dal cursore corrente.');
          }
        }

        this.backfillCursorUserId = '';
        this.backfillStatus =
          `Indice questionari aggiornato. Utenti: ${totalUsers}, ` +
          `percorsi: ${totalPercorsi}, righe: ${totalWritten}, rimosse: ${totalDeleted}.`;
        this.refreshIndexSubscription();
      } catch (error) {
        console.error('Errore aggiornando l\'indice questionari:', error);
        const message = error?.message || 'Errore durante l\'aggiornamento dell\'indice.';
        this.backfillError = this.backfillCursorUserId
          ? `${message} Puoi riprovare: il backfill ripartirà dal cursore salvato.`
          : message;
      } finally {
        this.backfillRunning = false;
      }
    },

    // ====== salvataggio nota interna staff ======
    async saveStaffNote(row) {
      const k = this.keyFor(row);
      const note = (this.staffNoteEdits[k] || '').trim();

      try {
        row._savingNote = true;
        const db = getFirestore();
        const ref = doc(db, 'percorsi', row.percorsoId);

        const snap = await getDoc(ref);
        const all = snap.exists() ? this.normalizeStepsArray(snap.data()?.steps) : [];
        const prev = all[row.stepIndex] || {};
        const nextStep = {
          ...prev,
          staffNote: note || null,
          adminUpdatedAt: new Date().toISOString(),
        };
        all[row.stepIndex] = nextStep;
        await updateDoc(ref, { steps: all });

        row.staffNote = note || '';
        row.stepSnapshot = { ...row.stepSnapshot, ...nextStep };
        this.saveStatus = { ...this.saveStatus, [k]: 'ok' };
      } catch (e) {
        console.error('saveStaffNote error:', e);
        this.saveStatus = { ...this.saveStatus, [k]: 'err' };
        alert('Errore nel salvataggio della nota interna.');
      } finally {
        row._savingNote = false;
      }
    },

    // ====== filtri ======
    resetFilters() {
      this.searchText = '';
      this.selectedAdmin = '';
      this.selectedStepKey = '';
      this.selectedTiming = '';
      this.selectedValutazione = '';
      this.selectedStudio = '';
      this.showImported = true;
      this.showSuperseded = false;
      this.showHidden = false;
      this.showOperationalHold = false;
      const range = this.defaultDateRange();
      this.dateFrom = range.from;
      this.dateTo = range.to;
      this.refreshIndexSubscription();
    },

    toggleImported() {
      this.showImported = !this.showImported;
      this.applyCombinedFilter();
    },

    toggleShowHidden() {
      this.showHidden = !this.showHidden;
      this.applyCombinedFilter();
    },

    toggleShowOperationalHold() {
      this.showOperationalHold = !this.showOperationalHold;
      this.applyCombinedFilter();
    },

    toggleShowSuperseded() {
      this.showSuperseded = !this.showSuperseded;
      this.applyCombinedFilter();
    },

    applyCombinedFilter() {
      const t = (this.searchText || '').toLowerCase();

      const passText = (q) => {
        if (!t) return true;
        const email = (q.userEmail || '').toLowerCase();
        if (email.includes(t)) return true;
        const staff = (q.staffNote || '').toLowerCase();
        if (staff.includes(t)) return true;
        const adminNote = (q.adminNote || '').toLowerCase();
        if (adminNote.includes(t)) return true;
        const product = (q.productName || '').toLowerCase();
        if (product.includes(t)) return true;
        const program = (q.programTitle || '').toLowerCase();
        if (program.includes(t)) return true;
        return (q.programTitleNormalized || '').toLowerCase().includes(t);
      };

      const passAdmin = (q) => {
        if (!this.selectedAdmin) return true;
        const s = (q.adminStatus || 'none');
        if (this.selectedAdmin === 'approved') return s === 'approved';
        if (this.selectedAdmin === 'needs_update') return s === 'needs_update';
        if (this.selectedAdmin === 'updated') return s === 'updated';
        if (this.selectedAdmin === 'todo') {
          return s === 'none' || s === 'updated' || s === 'needs_update';
        }
        if (this.selectedAdmin === 'none') return s === 'none';
        return true;
      };

      const passStep = (q) => !this.selectedStepKey || q.stepKey === this.selectedStepKey;
      const passTiming = (q) => !this.selectedTiming || this.timingState(q) === this.selectedTiming;
      const passStudio = (q) => {
        if (!this.selectedStudio) return true;
        return (q.userStudio || '') === this.selectedStudio;
      };
      const passImported = (q) => this.showImported || !q.isImported;
      const passSuperseded = (q) =>
        this.showSuperseded || (!q.hasCompletedLater && !q.hasRenewalAfterCompletedSequence);
      const passHidden = (q) => this.showHidden || !q.adminHidden;
      const passOperationalHold = (q) => this.showOperationalHold || !this.isOperationallyHidden(q);
      const passDateRange = (q) => {
        const planned = this.asDate(q.plannedAt);
        if (!planned) return false;
        if (this.dateFrom) {
          const from = this.asDate(this.dateFrom);
          if (from && planned < from) return false;
        }
        if (this.dateTo) {
          const to = this.asDate(this.dateTo);
          if (to) {
            const end = new Date(to);
            end.setHours(23, 59, 59, 999);
            if (planned > end) return false;
          }
        }
        return true;
      };

      this.filteredQuestionari = (this.rawFilteredData || []).filter(
        q => passText(q) && passAdmin(q) && passStep(q) && passTiming(q) && passStudio(q) && this.passValutazione(q) && passImported(q) && passSuperseded(q) && passHidden(q) && passOperationalHold(q) && passDateRange(q)
      );
    },

    async toggleHidden(row) {
      if (!row || !row.percorsoIdValid || row._togglingHidden) return;
      try {
        row._togglingHidden = true;
        const db = getFirestore();
        const ref = doc(db, 'percorsi', row.percorsoId);

        const snap = await getDoc(ref);
        const steps = snap.exists() ? this.normalizeStepsArray(snap.data()?.steps) : [];
        const prev = steps[row.stepIndex] || {};
        const nextHidden = !row.adminHidden;
        const nextStep = {
          ...prev,
          adminHidden: nextHidden,
          adminUpdatedAt: new Date().toISOString(),
        };
        steps[row.stepIndex] = nextStep;

        await updateDoc(ref, { steps });

        row.adminHidden = nextHidden;
        row.stepSnapshot = { ...row.stepSnapshot, ...nextStep };
        this.applyCombinedFilter();
      } catch (error) {
        console.error('toggleHidden error:', error);
        alert('Errore nel salvataggio della visibilità.');
      } finally {
        row._togglingHidden = false;
      }
    },

    // ====== azioni UI ======
    openAnswers(row) {
      this.activeRow = row;
      this.modalSearch = '';
      this.modalBundle = null;
      this.modalBundleError = '';
      this.modalLoading = false;
      this.showModal = true;
      this.prepareModalBundle(row);
    },
    handleQuestionarioClick(row) {
      if (!this.openQuestionarioPage(row)) {
        this.openAnswers(row);
      }
    },
    questionarioLinkLabel(row) {
      const target = this.resolveQuestionarioPath(row);
      if (target === 'check-finale') return 'Apri check finale';
      if (target === 'questionario') return 'Apri questionario';
      return 'Apri risposte';
    },
    resolveQuestionarioPath(row) {
      if (!row) return null;
      const typeKey = (row.type || '').toLowerCase();
      const stepKey = (row.stepKey || '').toLowerCase();
      if (typeKey === 'user_programmi_check_finale' || stepKey === 'check_finale') {
        return 'check-finale';
      }
      if (typeKey === 'user_programmi_questionario' || stepKey === 'questionario') {
        return 'questionario';
      }
      return null;
    },
    resolveQuestionarioRouteName(row) {
      const target = this.resolveQuestionarioPath(row);
      if (target === 'check-finale') return 'UserProgrammiCheckFinale';
      if (target === 'questionario') return 'UserProgrammiQuestionario';
      return null;
    },
    buildQuestionarioQuery(row) {
      const query = {};
      if (!row) return query;
      const assign = (key, value) => {
        if (value === undefined || value === null) return;
        const str = typeof value === 'string' ? value.trim() : String(value);
        if (str) query[key] = str;
      };
      assign('percorsoId', row.percorsoId);
      assign('stepIndex', row.stepIndex);
      assign('stepKey', row.stepKey);
      assign('sequenceGroupId', row.sequenceGroupId);
      assign('sequenceIndex', row.sequenceIndex);
      assign('sequenceTotal', row.sequenceTotal);
      assign('productId', row.productId);
      assign('productName', row.productName);
      assign('programTitle', row.programTitle || row.programLabel);
      assign('programLabel', row.programLabel || row.programTitle);
      assign('plannedStartAt', row.plannedStartAt);
      assign('expireAt', row.expireAt);
      assign('stepName', row.stepSnapshot?.name || row.stepName);
      assign('questionarioDocId', row.questionarioDocId);
      return query;
    },
    stringifyQueryParams(query) {
      const entries = Object.entries(query || {}).filter(([, value]) => value !== undefined && value !== null && value !== '');
      if (!entries.length) return '';
      if (typeof URLSearchParams !== 'undefined') {
        const usp = new URLSearchParams();
        entries.forEach(([key, value]) => usp.append(key, value));
        return usp.toString();
      }
      return entries.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    },
    openQuestionarioPage(row) {
      if (typeof window === 'undefined') return false;
      if (!row || !row.uid) return false;
      const routeName = this.resolveQuestionarioRouteName(row);
      const query = this.buildQuestionarioQuery(row);
      let href = '';

      if (routeName && this.$router && typeof this.$router.resolve === 'function') {
        const location = this.$router.resolve({
          name: routeName,
          params: { userId: row.uid },
          query,
        });
        href = location?.href || '';
      }

      if (!href) {
        const targetPath = this.resolveQuestionarioPath(row);
        if (!targetPath) return false;
        const queryString = this.stringifyQueryParams(query);
        href = `#/user/${row.uid}/programmi/${targetPath}${queryString ? `?${queryString}` : ''}`;
      }

      let targetHref = href;
      if (!/^https?:/i.test(targetHref || '')) {
        if (targetHref.startsWith('/#/')) {
          targetHref = targetHref.substring(1);
        } else if (targetHref.startsWith('/')) {
          targetHref = `#${targetHref}`;
        } else if (!targetHref.startsWith('#')) {
          targetHref = `#/${targetHref.replace(/^#?/, '')}`;
        }
      }
      window.open(targetHref, '_blank', 'noopener');
      return true;
    },
    closeModal() {
      this.showModal = false;
      this.activeRow = null;
      this.modalSearch = '';
      this.modalBundle = null;
      this.modalBundleError = '';
      this.modalLoading = false;
    },
    async prepareModalBundle(row) {
      if (!row || !row.uid) {
        this.modalBundle = { questionario: null, checkFinale: null };
        this.modalBundleError = row ? 'Utente non disponibile.' : '';
        this.modalLoading = false;
        return;
      }

      const cacheKey = `${row.uid}__${row.percorsoId || 'nopercorso'}`;
      if (this.bundleCache[cacheKey]) {
        this.modalBundle = this.bundleCache[cacheKey];
        return;
      }

      this.modalLoading = true;
      this.modalBundleError = '';

      try {
        const db = getFirestore();
        const constraints = [where('uid', '==', row.uid)];
        if (row.percorsoId) constraints.push(where('percorsoId', '==', row.percorsoId));

        const snap = await getDocs(query(collection(db, 'questionari'), ...constraints));
        const bundle = { questionario: null, checkFinale: null };

        const assignIfNewer = (targetKey, payload) => {
          const current = bundle[targetKey];
          if (!current) {
            bundle[targetKey] = payload;
            return;
          }
          const currentTime = (current.updatedAt || current.createdAt || new Date(0)).getTime();
          const nextTime = (payload.updatedAt || payload.createdAt || new Date(0)).getTime();
          if (nextTime >= currentTime) {
            bundle[targetKey] = payload;
          }
        };

        snap.forEach((docSnap) => {
          const data = docSnap.data() || {};
          const base = {
            docId: docSnap.id,
            answers: data.answers || {},
            templateLabel:
              data.templateLabel ||
              data.questionarioTemplateLabel ||
              data.questionarioTemplate ||
              '',
            createdAt: toDateSafe(data.createdAt || data.created_at || null),
            updatedAt: toDateSafe(data.updatedAt || data.updated_at || data.createdAt || null),
            stepKey: data.stepKey || null,
            type: data.type || null,
          };

          const typeKey = (base.type || '').toLowerCase();
          const stepKey = (base.stepKey || '').toLowerCase();

          if (typeKey === 'user_programmi_questionario' || stepKey === 'questionario') {
            assignIfNewer('questionario', base);
          } else if (typeKey === 'user_programmi_check_finale' || stepKey === 'check_finale') {
            assignIfNewer('checkFinale', base);
          }
        });

        this.bundleCache = { ...this.bundleCache, [cacheKey]: bundle };
        this.modalBundle = bundle;
      } catch (error) {
        console.error('Errore caricando i questionari correlati:', error);
        this.modalBundleError = 'Impossibile recuperare tutti i dati salvati.';
        this.modalBundle = { questionario: null, checkFinale: null };
      } finally {
        this.modalLoading = false;
      }
    },
    gotoUser(uid) {
      if (!uid) return;
      window.open(`#/user/${uid}/anagrafica`, '_blank');
    },

    // ====== util UI ======
    adminLabel(s) {
      const v = s || 'none';
      if (v === 'approved') return 'Approvato';
      if (v === 'needs_update') return 'Richiesto aggiornamento';
      if (v === 'updated') return 'Aggiornato';
      return '—';
    },
    adminChipClass(s) {
      const v = s || 'none';
      return {
        'chip-green': v === 'approved',
        'chip-orange': v === 'needs_update',
        'chip-blue': v === 'updated',
        'chip-neutral': v === 'none'
      };
    },

    stepCloneLabel(row) {
      if (!row) return '';
      const key = (row.stepKey || '').toLowerCase();
      if (key !== 'questionario') return '';
      const label = (row.questionarioTemplateLabel || '').trim();
      if (label) return label;
      const tplKey = (row.questionarioTemplateKey || '').toLowerCase();
      if (tplKey === 'check_finale') return 'check';
      return '';
    },
    sectionTitle(row) {
      if (!row) return 'Dettagli';
      const key = (row.stepKey || '').toLowerCase();
      if (key === 'questionario') return 'Questionario Programmi';
      if (key === 'check_finale') return 'Check Finale Programmi';
      if (key === 'feedback_programmi') return 'Feedback Programmi';
      if (key === 'consegna') return 'Consegna';
      return prettifyKey(key || 'Dettagli');
    },
    sectionSubtitle(row) {
      if (!row) return '';
      return row.questionarioTemplateLabel || row.questionarioTemplateKey || row.templateId || '';
    },
    buildSectionGroups(typeKey, answers, searchTerm) {
      if (!answers || typeof answers !== 'object') return [];
      const normalized = (typeKey || '').toLowerCase();
      if (normalized === 'questionario' || normalized === 'user_programmi_questionario') {
        return buildQuestionarioSections(answers, searchTerm).map((section) => ({
          key: section.key,
          title: section.title,
          entries: section.entries,
        }));
      }
      if (normalized === 'check_finale' || normalized === 'user_programmi_check_finale') {
        return buildCheckFinaleSections(answers, searchTerm).map((section) => ({
          key: section.key,
          title: section.title,
          entries: section.entries,
        }));
      }
      return this.buildFallbackSections(answers, searchTerm);
    },
    buildFallbackSections(answers, searchTerm) {
      const entries = flattenAnswers(answers || {});
      const needle = (searchTerm || '').trim().toLowerCase();
      const groups = new Map();

      entries.forEach((entry) => {
        const haystack = `${entry.label} ${entry.display}`.toLowerCase();
        if (needle && !haystack.includes(needle)) return;
        const key = entry.root;
        if (!groups.has(key)) {
          groups.set(key, {
            key,
            title: prettifyKey(key),
            entries: [],
          });
        }
        groups.get(key).entries.push(entry);
      });

      return Array.from(groups.values()).map((group) => {
        group.entries.sort((a, b) => a.label.localeCompare(b.label));
        return group;
      });
    },

    stringifySmall(v) {
      try {
        if (v == null) return '';
        if (typeof v === 'string') return v;
        if (typeof v === 'number' || typeof v === 'boolean') return String(v);
        if (Array.isArray(v)) return v.map(this.stringifySmall).join(', ');
        const s = JSON.stringify(v);
        return s?.length > 500 ? s.slice(0, 500) + '…' : s;
      } catch { return String(v ?? ''); }
    },

    formatDate(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.toLocaleDateString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric' });
    },
    formatDateTime(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.toLocaleString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
    },

    async sendAdminNotification(row) {
      if (!row || row._sendingNotification) return;
      if (!row.uid) {
        alert('Utente non disponibile per la notifica.');
        return;
      }
      if (!row.percorsoId) {
        alert('Programma non trovato per la notifica.');
        return;
      }

      row._sendingNotification = true;
      try {
        const db = getFirestore();
        const step = row.stepSnapshot || {};
        const payload = await dispatchStepNotification({
          db,
          userUid: row.uid,
          programId: row.percorsoId,
          stepKey: row.stepKey,
          step,
          stepIndex: row.stepIndex,
          programTitle: row.programTitleNormalized || normalizeProgramTitle(row.programTitle || ''),
          productName: row.productName || null,
          sequenceIndex: Number.isFinite(row.sequenceIndex) ? row.sequenceIndex : null,
          sequenceTotal: Number.isFinite(row.sequenceTotal) ? row.sequenceTotal : null,
          plannedAt: step?.plannedAt || row.plannedAt || null,
          notifyUser: true,
          preserveOpenStatus: true,
          awaitNotification: false,
        });

        if (!payload) {
          alert('Non è stato possibile generare la notifica per questo step.');
          return;
        }

        alert(payload.toastMessage || 'Notifica inviata.');
      } catch (error) {
        console.error('sendAdminNotification error:', error);
        alert("Errore nell'invio della notifica.");
      } finally {
        row._sendingNotification = false;
      }
    }
  }
};
</script>

<style scoped>
.fb-red    { background-color: #fee2e2; }
.fb-orange { background-color: #fef3c7; }
.fb-green  { background-color: #dcfce7; }

.note-input {
  width: 100%;
  min-width: 140px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #111;
}

.profile-button { background: none; border: none; cursor: pointer; }

.card-surface {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  padding: 18px 20px;
  margin-top: 18px;
}

.titolo-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.titolo-card__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.page-help {
  margin-top: 16px;
  padding: 16px 18px;
  border-radius: 16px;
  border: 1px solid #dbeafe;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.page-help__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 12px;
}

.page-help__title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.page-help__subtitle {
  font-size: 0.82rem;
  color: #64748b;
}

.page-help__items {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.page-help__item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

.page-help__item strong {
  font-size: 0.84rem;
  color: #0f172a;
}

.page-help__item span {
  font-size: 0.82rem;
  line-height: 1.45;
  color: #475569;
}

.backfill-feedback {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  font-size: 0.85rem;
}

.backfill-feedback .error {
  color: #b91c1c;
  font-weight: 600;
}

.toolbar-card {
  margin-top: 24px;
}

.filters-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.accordion-toggle {
  flex: 1 1 320px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  cursor: pointer;
  transition: border 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.accordion-toggle:hover {
  background: #fff;
  border-color: #cbd5e1;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.accordion-toggle .material-icons {
  font-size: 22px;
  color: #475569;
}

.toggle-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toggle-title {
  font-weight: 700;
  font-size: 0.95rem;
}

.toggle-subtitle {
  font-size: 0.82rem;
  color: #64748b;
}

.accordion-panel {
  margin-top: 14px;
  padding: 14px 12px;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.18s ease;
}

.accordion-enter,
.accordion-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.toolbar-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 auto;
}

.toolbar-group--lg { width: 240px; }
.toolbar-group--md { width: 200px; }
.toolbar-group--sm { width: 160px; }

.toolbar-actions {
  display: flex;
  gap: 12px;
  flex: 0 0 auto;
  align-items: center;
}

.toolbar-actions--ghosts {
  flex-wrap: wrap;
}

.toolbar-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.date-range-input {
  width: 100%;
}

.date-range-input--short {
  width: 84% !important;
}

.input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  outline: none;
}

.input--compact {
  max-width: 220px;
  padding: 8px 12px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid transparent;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
  background: #f1f5f9;
  color: #1e293b;
  border-color: #e2e8f0;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.btn.primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #fff;
}

.btn.ghost {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #e2e8f0;
}

.btn.ghost.active {
  background: #e0f2fe;
  color: #0ea5e9;
  border-color: #bae6fd;
  box-shadow: 0 6px 16px rgba(14, 165, 233, 0.15);
}

.btn.tiny {
  font-size: 0.78rem;
  padding: 6px 10px;
}

.tickets { overflow-x:auto; }
table { width:100%; min-width:1250px; border-collapse:collapse; table-layout:fixed; }
th, td { padding:8px 12px; text-align:left; border-bottom:1px solid #eee; vertical-align:top; white-space:normal; }
thead th { background:#f7f7f7; }

.col-idx{ width:60px; } .col-azione{ width:160px; }
.col-admin{ width:360px; } .col-note{ width:260px; }
.col-data{ width:160px; } .col-email{ width:260px; }
.col-prodotto{ width:240px; } .col-sequenza{ width:120px; }
.col-step{ width:160px; }

.muted{ color:#6b7280; }

.user-questionari-group-row td {
  background: #fef3c7;
  border-bottom-color: #f59e0b;
}

.user-questionari-group-row.is-open td {
  background: #fde68a;
}

.user-questionari-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.user-questionari-group__toggle {
  flex: 1 1 420px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: #78350f;
  text-align: left;
  cursor: pointer;
}

.user-questionari-group__toggle .material-icons {
  font-size: 24px;
  color: #92400e;
}

.user-questionari-group__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.user-questionari-group__copy strong {
  color: #451a03;
  font-size: 0.96rem;
}

.user-questionari-group__copy span {
  color: #78350f;
  font-size: 0.84rem;
  line-height: 1.35;
}

.user-questionari-group__meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.user-questionari-child-row td {
  background: #fffbeb;
  border-bottom-color: #fde68a;
}

.user-questionari-child-row:hover td {
  background: #fef3c7;
}

.step-cell { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }
.step-tag {
  display:inline-flex;
  align-items:center;
  gap:4px;
  font-size:0.78rem;
  color:#475569;
  background:#eef2ff;
  border-radius:999px;
  padding:2px 8px;
  border:1px solid #c7d2fe;
}

.admin-col { min-width: 340px; }
.admin-row { display: grid; gap: 6px; }
.admin-chip {
  display:inline-block; padding:3px 8px; border-radius:999px;
  border: 1px solid #e5e7eb; font-size: .78rem; line-height: 1.25rem;
  background:#f3f4f6; color:#374151;
}
.chip-neutral { background:#f3f4f6; }
.chip-green   { background:#dcfce7; color:#065f46; border-color:#bbf7d0; }
.chip-orange  { background:#fff7ed; color:#9a3412; border-color:#fed7aa; }
.chip-blue    { background:#dbeafe; color:#1d4ed8; border-color:#bfdbfe; }
.chip-purple  { background:#f3e8ff; color:#7c3aed; border-color:#e9d5ff; }
.chip-red     { background:#fee2e2; color:#b91c1c; border-color:#fecaca; }
.chip-dark    { background:#111827; color:#f9fafb; border-color:#111827; }
.chip-yellow  { background:#fef3c7; color:#92400e; border-color:#fcd34d; }
.chips-line { display:flex; gap:6px; flex-wrap:wrap; align-items:center; }

.planned-at-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.buttons-container { display:flex; gap:6px; align-items:center; flex-wrap:wrap; }
.grey{ background:#7e7e7e; color:#fff; border:1px solid #646464; padding:6px 10px; border-radius:10px; font-size:.85rem;}
.dark{ background:#111827; color:#fff; border:1px solid #0f172a; padding:6px 10px; border-radius:10px; font-size:.85rem;}

.modal .dialog { background:#fff; width:min(1007px,94vw); height:min(95vh, 860px); border-radius:14px; box-shadow:0 24px 60px rgba(0,0,0,.25); padding:18px; display:flex; flex-direction:column; }
.modal-head { display:flex; justify-content:space-between; align-items:center; gap:10px; margin-bottom:8px; }
.meta { display:grid; grid-template-columns: repeat(auto-fit,minmax(240px,1fr)); gap:8px; margin-bottom:10px; }
.meta-step { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }

.modal-scroll { flex:1; overflow:auto; padding-right:8px; }
.answers { display:grid; gap:12px; }
.data-state {
  padding: 14px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  font-size: 0.92rem;
  color: #1f2937;
  text-align: center;
}
.data-state.error {
  color: #b91c1c;
  border-color: rgba(185, 28, 28, 0.35);
  background: rgba(248, 113, 113, 0.08);
}

.modal-sections {
  display: grid;
  gap: 18px;
}

.modal-section {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-section__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.modal-section__head h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.modal-section__subtitle {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #475569;
}

.modal-section__meta {
  font-size: 0.82rem;
  color: #1f2937;
  font-weight: 500;
}

.modal-section__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal-group__title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1d4ed8;
  text-transform: capitalize;
}

.modal-row {
  display: grid;
  grid-template-columns: minmax(150px, 220px) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.modal-row.multiline {
  align-items: stretch;
}

.modal-row__key {
  font-size: 0.86rem;
  font-weight: 600;
  color: #1f2937;
  word-break: break-word;
}

.modal-row__value {
  font-size: 0.86rem;
  color: #0f172a;
  word-break: break-word;
}

.row-imported {
  background: rgba(14, 116, 144, 0.08);
}

.row-imported td {
  border-bottom-color: rgba(14, 116, 144, 0.2);
}

.step-tag--imported {
  color: #0f766e;
}

.modal-row__value pre {
  margin: 0;
  font-size: 0.82rem;
  background: none;
  white-space: pre-wrap;
  font-family: 'SFMono-Regular', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}

</style>
